import { Fragment, useState } from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  DvrOutlined,
  Diversity2Outlined,
  Healing,
  HomeOutlined,
  LocalPharmacyOutlined,
  DriveFileRenameOutline,
  MedicationOutlined,
  ImageOutlined,
  TaskOutlined,
  SentimentSatisfiedOutlined,
  RestaurantMenu,
  VerifiedUserOutlined,
  ExpandMore,
  MonitorHeartOutlined,
  MasksOutlined,
  SickOutlined,
  PsychologyOutlined,
  ErrorOutlineOutlined,
  AutorenewOutlined,
} from '@mui/icons-material';

import Survey from '../Survey';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import { IToggleObj } from './type';
import { initialToggleObj } from './initialStates';

interface Props {
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRef: any;
}

const MenuRecords = (props: Props) => {
  const { menuDrawerWidth, setMenuDrawerWidth, coachRef } = props;

  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);

  const menus = [
    {
      icon: <DvrOutlined />,
      label: 'e-CARDEX',
    },
    {
      disabled: true,
      icon: <AutorenewOutlined />,
      label: 'SBAR',
      id: 'sbar',
    },
    {
      label: 'SBAR 1',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 2',
      toggle: toggle.sbar,
    },
    {
      label: 'SBAR 3',
      toggle: toggle.sbar,
    },
    {
      icon: <Diversity2Outlined />,
      label: 'Nurse Take Over',
    },
    {
      icon: <Healing />,
      label: 'Inpatient Record',
    },
    {
      icon: <HomeOutlined />,
      label: 'Discharge Record',
    },
    {
      icon: <LocalPharmacyOutlined />,
      label: 'Patient status &prescription',
    },
    {
      icon: <DriveFileRenameOutline />,
      label: 'Nursing Record',
    },
    {
      icon: <MedicationOutlined />,
      label: 'Medication Record',
    },
    {
      icon: <ImageOutlined />,
      label: 'Radiography Record',
    },
    {
      icon: <TaskOutlined />,
      label: 'Clinical Pathology',
    },
    {
      disabled: true,
      icon: <MonitorHeartOutlined />,
      label: 'Clinical \nObservation',
      id: 'clinical_obv',
    },
    {
      label: 'Vital Sign',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'I/O',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Blood Sugar Log',
      toggle: toggle.clinical_obv,
    },
    {
      label: 'Clinical observation\n(ICU)',
      toggle: toggle.clinical_obv,
    },
    {
      disabled: true,
      icon: <SentimentSatisfiedOutlined />,
      label: 'Patient Assessment',
      id: 'patient_evaluation',
    },
    {
      label: 'Morse Fall Scale',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Humty Dumpty \nFall Scale',

      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Braden Scale',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Needs Assessment',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Pediatric GCS',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'FOUR Score',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Patient Safety Report',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Patient\nSafety Reporting\nand Learning System',
      toggle: toggle.patient_evaluation,
    },
    {
      label: 'Adverse Drug Reaction \nReporting System',
      toggle: toggle.patient_evaluation,
    },

    {
      icon: <SickOutlined />,
      disabled: true,
      label: 'Pain Assessment',
      id: 'pain',
    },
    {
      label: 'NRS',
      toggle: toggle.pain,
    },
    {
      label: 'FLACC Scale',
      toggle: toggle.pain,
    },
    // {
    //   label: 'CNPS',
    //   toggle: toggle.pain,
    // },
    {
      label: 'FFI',
      toggle: toggle.pain,
    },
    {
      label: 'KOOS',
      toggle: toggle.pain,
    },
    {
      label: 'LEFS',
      toggle: toggle.pain,
    },
    {
      label: 'NDI',
      toggle: toggle.pain,
    },
    {
      label: 'STarT Back\nScreening',
      toggle: toggle.pain,
    },
    {
      icon: <PsychologyOutlined />,
      disabled: true,
      label: 'Psychiatric',
      id: 'mental_health',
    },
    {
      label: 'Mental\nHealth\nRecords',
      toggle: toggle.mental_health,
    },
    {
      label: 'BDI',
      toggle: toggle.mental_health,
    },
    {
      label: 'BAI',
      toggle: toggle.mental_health,
    },
    {
      label: 'MMSE',
      toggle: toggle.mental_health,
    },

    {
      disabled: true,
      icon: <MasksOutlined />,
      label: 'Special part Record',
      id: 'special',
    },
    {
      label: 'Surgery',
      toggle: toggle.special,
    },
    {
      label: 'Anesthetic',
      toggle: toggle.special,
    },
    {
      label: 'Transfusion',
      toggle: toggle.special,
    },
    {
      label: 'Intubation',
      toggle: toggle.special,
    },
    {
      label: 'CPR',
      toggle: toggle.special,
    },
    {
      label: 'Dialysis',
      toggle: toggle.special,
    },
    {
      label: 'Emergency',
      toggle: toggle.special,
    },
    {
      label: 'Delivery',
      toggle: toggle.special,
    },
    {
      label: 'Home Care',
      toggle: toggle.special,
    },
    {
      icon: <RestaurantMenu />,
      label: 'Diet and Nutrition',
    },
    {
      disabled: true,
      icon: <VerifiedUserOutlined />,
      label: 'Agreement',
      id: 'agreement',
    },
    {
      label: 'Patient\nGuide',
      toggle: toggle.agreement,
    },
    {
      label: 'Patient\nConsent\nForm',
      toggle: toggle.agreement,
    },
    {
      label: 'Blood\nTransfusion',
      toggle: toggle.agreement,
    },
    {
      label: 'Conscious Sedation',
      toggle: toggle.agreement,
    },
    {
      label: 'DNR',
      toggle: toggle.agreement,
    },
    {
      label: 'Admission Agreement',
      toggle: toggle.agreement,
    },
    {
      label: 'Admission Guide',
      toggle: toggle.agreement,
    },
    {
      label: 'Admission Check List',
      toggle: toggle.agreement,
    },
    {
      label: 'Fall\nPrevention',
      toggle: toggle.agreement,
    },
    {
      label: 'CRRT',
      toggle: toggle.agreement,
    },
    {
      label: 'CVC\nInsertion',
      toggle: toggle.agreement,
    },
    {
      label: 'ETI',
      toggle: toggle.agreement,
    },
    {
      label: 'Physical\nRestraint',
      toggle: toggle.agreement,
    },
    // {
    //   icon: <BabyChangingStation />,
    //   label: 'Children Examination',
    // },
    {
      disabled: true,
      icon: <ErrorOutlineOutlined />,
      label: 'Informatics\nand Nursing',
      id: 'information',
    },
    {
      label: 'Generative\nAI Nursing\nRecord',
      toggle: toggle.information,
    },
    {
      label: 'Chat\nGPT',
      toggle: toggle.information,
    },
    {
      label: 'Google\nGemini',
      toggle: toggle.information,
    },
  ];

  const onClickListItem = (label: string) => {
    if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === 'Patient\nSafety Reporting\nand Learning System') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === 'Adverse Drug Reaction \nReporting System') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Generative\nAI Nursing\nRecord') {
      window.open('https://chatbot2-enr-en.streamlit.app/');
      return;
    } else if (label === 'Chat\nGPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google\nGemini') {
      window.open('https://bard.google.com/');
      return;
    }

    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const onClickDisabledItem = (sublabel: string | undefined) => {
    let newToggle = { ...toggle };

    // if (menuDrawerWidth !== 300) {
    //   if (sublabel) newToggle[sublabel] = true;
    //   setToggle(newToggle);
    //   setMenuDrawerWidth(300);
    //   return;
    // }

    if (sublabel === 'sbar') {
      newToggle['sbar'] = !newToggle['sbar'];
      newToggle['clinical_obv'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'clinical_obv') {
      newToggle['clinical_obv'] = !newToggle['clinical_obv'];
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'patient_evaluation') {
      newToggle['patient_evaluation'] = !newToggle['patient_evaluation'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'pain') {
      newToggle['pain'] = !newToggle['pain'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'mental_health') {
      newToggle['mental_health'] = !newToggle['mental_health'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'special') {
      newToggle['special'] = !newToggle['special'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['agreement'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'agreement') {
      newToggle['agreement'] = !newToggle['agreement'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['information'] = false;
    } else if (sublabel === 'information') {
      newToggle['information'] = !newToggle['information'];
      newToggle['clinical_obv'] = false;
      newToggle['sbar'] = false;
      newToggle['patient_evaluation'] = false;
      newToggle['pain'] = false;
      newToggle['mental_health'] = false;
      newToggle['special'] = false;
      newToggle['agreement'] = false;
    }

    setToggle(newToggle);
  };

  return (
    <Fragment>
      {menus.map(({ icon, label, disabled, toggle, id }) => {
        const onClick = () => {
          if (disabled) onClickDisabledItem(id);
          else onClickListItem(label);
        };

        const MoreIcon = () => {
          if (!disabled) return null;
          return <ExpandMore fontSize="small" sx={{ color: '#fff' }} />;
        };

        if (disabled) {
          return (
            <>
              {icon ? (
                <ListItem
                  key={label}
                  disablePadding
                  ref={label === 'Special part Record' ? coachRef : null}
                  sx={{ whiteSpace: 'pre-wrap' }}
                >
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        margin: '8px 0 6px 0',
                        justifyContent: 'center',
                        width: '80px',
                      }}
                    >
                      {icon}
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                    />
                  </ListItemButton>
                </ListItem>
              ) : toggle ? (
                <ListItem key={label} disablePadding>
                  <ListItemButton
                    onClick={onClick}
                    sx={{
                      display: 'block',
                      width: '80px',
                      height: '80px',
                      padding: '0px',
                      alignItems: 'center',
                      borderRadius: '8px',
                      margin: '7px',
                    }}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                      }}
                      primary={label}
                      sx={{ whiteSpace: 'pre-wrap' }}
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          );
        }

        return (
          <>
            {icon ? (
              <ListItem
                key={label}
                disablePadding
                ref={label === 'Special part Record' ? coachRef : null}
                sx={{ whiteSpace: 'pre-wrap' }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width: '80px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      margin: '8px 0 6px 0',
                      justifyContent: 'center',
                      width: '80px',
                      '&:hover': {
                        color: 'red',
                      },
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      fontSize: '12px',
                      textAlign: 'center',
                    }}
                    primary={label}
                  />
                </ListItemButton>
              </ListItem>
            ) : toggle ? (
              <ListItem
                key={label}
                disablePadding
                sx={{
                  width:
                    label === 'Patient\nSafety Reporting\nand Learning System'
                      ? '120px'
                      : label === 'Adverse Drug Reaction \nReporting System'
                      ? '150px'
                      : '100px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                <ListItemButton
                  onClick={onClick}
                  sx={{
                    display: 'block',
                    width:
                      label === 'Patient\nSafety Reporting\nand Learning System'
                        ? '120px'
                        : label === 'Adverse Drug Reaction \nReporting System'
                        ? '150px'
                        : '100px',
                    height: '80px',
                    padding: '0px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    margin: '7px',
                    backgroundColor: 'white',
                    ':hover': {
                      boxShadow: '1px 0px 3px 0px #E2E2E2',
                      borderRadius: '8px',
                    },
                  }}
                >
                  <div
                    style={{
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'white',
                      marginTop: '-0.5px',
                      borderRadius: '8px',
                    }}
                  >
                    <ListItemText
                      className="DropMenu"
                      primaryTypographyProps={{
                        fontSize: '12px',
                        textAlign: 'center',
                        fontWeight: 500,
                      }}
                      primary={label}
                    />
                  </div>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        );
      })}

      <Survey />
    </Fragment>
  );
};

export default MenuRecords;
